module.exports = __webpack_public_path__ + "static/media/back.39c5d7e9.svg";